<span class="is-relative">
    <ng-container *ngIf="files$ | async as files">
        <span *ngFor="let file of files; let last = last">
            <a [href]="downloadUrl(file['@id'])" download target="_blank"> {{ file.name }} </a>
            <span *ngIf="files.length > 1 && !last">, </span>
        </span>
    </ng-container>
    <isav-loader class="ml-3 mt-3" *ngIf="showLoaderWhileLoading && loading"></isav-loader>
</span>
